{
  "otherOrganizations": "Other organizations",
  "solutionIframe": "Main Content",
  "unloadPromptMessage": "Are you sure?"
} 
